import React, { Component } from 'react';
import ScreenContainer from './screen/ScreenContainer';
import ButtonsContainer from './buttons/ButtonsContainer';
import HelpBoxContainer from "../helpbox/HelpBoxContainer";
import './Remote.scss';

class Remote extends Component {
  render() {

    return (
      <div className='RemoteContainer'>
        <div className='Remote'>
          <ScreenContainer/>
          <ButtonsContainer/>
        </div>
        <HelpBoxContainer/>
      </div>
    );
  }
}

export default Remote;
